import { PermissionKey } from '../PermissionKey';

export const supervisorPermissionKeys = [
  PermissionKey.SiteDetails,
  PermissionKey.SitesSiteOverviewSidebar,
  PermissionKey.SitesSiteOverviewToggleSidebar,
  PermissionKey.SitesSiteOverviewSidebarSelectAreas,
  PermissionKey.SitesSiteOverviewUpdateFiltrationInfo,
  PermissionKey.SitesSiteOverviewUpdateStabilizationInfo,
  PermissionKey.SitesSiteOverviewUpdatePackingInfo,
  PermissionKey.SitesSiteOverviewUpdateBeerRecoveryInfo,

  PermissionKey.SitesPROFiLineStatus,
  PermissionKey.SitesPROFiLineStatusDetailsCard,
  PermissionKey.SitesPROFiLineStatusWidget,
  PermissionKey.SitesPROFiLineStatusWidgetHide,

  PermissionKey.SitesPROFiStatistics,

  PermissionKey.SitesPROFiFilterRuns,

  PermissionKey.SitesPROFiDocumentation,
  PermissionKey.SitesPROFiReports,
  PermissionKey.SitesPROFiReportsAdd,
  PermissionKey.SitesPROFiClusters,
  PermissionKey.SitesPROFiBrandEdit,
  PermissionKey.SitesPROFiMembraneInfo,
  PermissionKey.SitesPROFiSystemEdit,

  PermissionKey.SitesCBSLineStatus,
  PermissionKey.SitesCBSLineStatusDetailsCard,
  PermissionKey.SitesCBSLineStatusWidget,
  PermissionKey.SitesCBSLineStatusWidgetHide,

  PermissionKey.SitesCBSStatistics,

  PermissionKey.SitesCBSDocumentation,
  PermissionKey.SitesCBSReports,
  PermissionKey.SitesCBSReportsAdd,
  PermissionKey.SitesCBSBrandEdit,
  PermissionKey.SitesCBSSystemEdit,

  PermissionKey.SitesCFSLineStatus,
  PermissionKey.SitesCFSLineStatusDetailsCard,
  PermissionKey.SitesCFSLineStatusWidget,
  PermissionKey.SitesCFSLineStatusWidgetHide,
  PermissionKey.SitesCFSFilterRuns,
  PermissionKey.SitesCFSStatistics,
  PermissionKey.SitesCFSDocumentation,
  PermissionKey.SitesCFSReports,
  PermissionKey.SitesCFSReportsAdd,
  PermissionKey.SitesCFSSystemEdit,

  PermissionKey.SitesKerafluxLineStatus,
  PermissionKey.SitesKerafluxLineStatusDetailsCard,
  PermissionKey.SitesKerafluxLineStatusWidget,
  PermissionKey.SitesKerafluxLineStatusWidgetHide,
  PermissionKey.SitesKerafluxDocumentation,
  PermissionKey.SitesKerafluxBatchInfo,
  PermissionKey.SitesKerafluxReports,
  PermissionKey.SitesKerafluxReportsAdd,
  PermissionKey.SitesKerafluxStatistics,
  PermissionKey.SitesKerafluxSystemEdit,

  PermissionKey.ExecutiveSummaryMachine,
  PermissionKey.ExecutiveSummaryMachineTimeframeSelection,

  PermissionKey.ExecutiveSummaryMembraneBlock,

  PermissionKey.ExecutiveSummaryCompareLines,
  PermissionKey.ExecutiveSummaryCompareLinesFilterByLines,
  PermissionKey.ExecutiveSummaryCompareBrands,

  PermissionKey.Analytics,

  PermissionKey.AlertWidget,

  PermissionKey.AlertHistory,
  PermissionKey.AlertHistoryDetails,
  PermissionKey.AlertHistoryDismiss,

  PermissionKey.Settings,

  PermissionKey.SettingsAccount,
  PermissionKey.SettingsAccountEdit,

  PermissionKey.SettingsUserManagement,

  PermissionKey.SettingsAlerts,
  PermissionKey.SettingsAlertsEdit,

  PermissionKey.SettingsReporting,
  PermissionKey.SettingsReportingCreate,
  PermissionKey.SettingsReportingEdit,

  PermissionKey.SettingsChangePassword,

  PermissionKey.SettingsLocalUtilityCosts,
  PermissionKey.SettingsLocalUtilityCostsEdit,
  PermissionKey.SettingsLocalUtilityBillingUnitsEdit,

  PermissionKey.SettingsPallNotifications,
  PermissionKey.SettingsPallNotificationsSelectRoles,

  PermissionKey.SettingsBeerTypes,
  PermissionKey.SettingsBeerTypesDelete,
  PermissionKey.SettingsBeerTypesAdd,

  PermissionKey.SettingsProvisioning,
  PermissionKey.SettingsProvisioningStartSetup,
  PermissionKey.SettingsCertificateProvisioning,
  PermissionKey.SettingsCertificateProvisioningGenerate,

  PermissionKey.SettingsThresholds,
  PermissionKey.SettingsThresholdsEdit,
  PermissionKey.SettingsThresholdsConsumptionCalulationEdit,
  PermissionKey.SettingsThresholdsCloneSettings,

  PermissionKey.SettingsPushNotifications,
];
